import { render, staticRenderFns } from "./Cancela.vue?vue&type=template&id=cbad744a"
import script from "./Cancela.vue?vue&type=script&lang=js"
export * from "./Cancela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports